import React from "react";
import { RolesAuthRoute } from "../Context/ProtectedRoute";
import { ChannelAuthRoute } from "../Context/ProtectedRoute";
export const createProtectedRoutes = (routesConfig) =>
  routesConfig.map(({ path, component: Component, roles, channel = null }) => ({
    path,
    element: (
      <RolesAuthRoute roles={roles}>
        <ChannelAuthRoute channel={channel}>
          <Component />
        </ChannelAuthRoute>
      </RolesAuthRoute>
    ),
  }));
